// extracted by mini-css-extract-plugin
module.exports = {"thumbnail":"thumbnail-module--thumbnail--2nLji","noBorder":"thumbnail-module--noBorder--3sQKh","author":"thumbnail-module--author--1U-NI","image":"thumbnail-module--image--_tHNY"};